// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","PlaceholderWrapper":"PlaceholderWrapper-25vhjw5589rx28d3nncz3b2e6fst1f8e2ap62afhqnjsx79zt81kxh8jtek17mrn3p186v84pf3r2cmtucet4wjmvchkcjrb65cyjcm","pulse":"pulse-4swy7d9va9g7qpw1yvu6xk9nqjmfpqq29d2mabx31xehwjy88s98aad8mbaahue9yp71p75145xzdqqagz6zhdhjnpr11pfnxbxkwr8","loading":"loading-3x4933yf6btnq17hudvz2dxacszv2dzpjm49zsaqwes4k3xr9m335au8pdfd71bcukcbtwr5n2ryzn1e5yxnw3wbctw458x3rcsfsvh"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Placeholder/Placeholder.module.scss
// module id = 1308
// module chunks = 0